<h1
  class="text-primary-blue mb-8 flex flex-row items-center text-2xl font-bold md:space-x-4"
  tabindex="-1"
>
  <span class="bg-primary-blue hidden h-20 w-20 rounded-full p-3 md:block">
    <slot name="image"></slot>
  </span>
  <slot></slot>
</h1>
